import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiStudentBold } from "react-icons/pi"
import { callApi, CDN_URL, getInlineLoader } from "../Helpers"
import OneStudentExamCycleResult from "../ones/OneStudentExamCycleResult"
import { FaChevronDown } from "react-icons/fa"

export default function View({ uuid }) {
  const appContext = useContext(AppContext)

  const [ready, setReady] = useState(false)
  const [data, setData] = useState(null)
  const [academicProfile, setAcademicProfile] = useState(null)
  const [loading, setLoading] = useState(false)

  async function init() {
    setReady(false)
    await Promise.all([getData(), getAcademicProfile()])
    setReady(true)
  }

  async function getData() {
    await callApi("get-student-data", { uuid }).then(response => {
      if (response.status === 1) {
        setData(response.data)
      } else {
        appContext.tellError("Could not fetch data, check your connection")
      }
    })
  }

  async function getAcademicProfile() {
    await callApi("get-student-academic-profile", { uuid }).then(response => {
      if (response.status === 1) {
        setAcademicProfile(response.data)
      } else {
        appContext.tellError("Could not fetch data, check your connection")
      }
    })
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading)
    return () => {
      appContext.setShowOverlayLoader(false)
    }
  }, [loading])

  if (ready && data && academicProfile) {
    return (
      <div className="container">
        <div className="row">

          <div className="col-12 mb-4">
            <h6 className="main-section-title">
              Student&apos;s Academic Profile for {data.firstName} {data.middleName} {data.lastName}
              <br />
              <span className="badge bg-primary">Student</span>
            </h6>
            <hr />
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <div
              style={{
                width: "150px",
                height: "150px",
                margin: "0 auto",
                borderRadius: "20px",
                overflow: "hidden",
                cursor: "pointer",
              }}
              className="bg-surface mShadow1"
            >
              {data.passportPic ? (
                <img
                  src={CDN_URL + data.passportPic}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              ) : (
                <PiStudentBold
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  className="text-muted"
                />
              )}
            </div>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">First Name</label>
            <h6 style={{ fontSize: "18px" }}>{data.firstName || "N/A"}</h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Middle Name</label>
            <h6 style={{ fontSize: "18px" }}>{data.middleName || "N/A"}</h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Last Name</label>
            <h6 style={{ fontSize: "18px" }}>{data.lastName || "N/A"}</h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Classroom</label>
            <h6 style={{ fontSize: "18px" }}>{data.classroomName || "N/A"}</h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Stream</label>
            <h6 style={{ fontSize: "18px" }}>{data.streamName || "N/A"}</h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Date of Birth</label>
            <h6 style={{ fontSize: "18px" }}>{data.birthDate || "N/A"}</h6>
          </div>

          {/* Examination Results */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection1"
                  aria-expanded="false"
                  aria-controls="_studentSection1"
                >
                  <h6 className="card-title align-self-center">Examination Results</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>

                <div className="collapse" id="_studentSection1">
                  <hr />
                  {academicProfile.examResults && academicProfile.examResults.length > 0 ? (
                    academicProfile.examResults.map((item, i) => (
                      <OneStudentExamCycleResult studentUuid={uuid} data={item} key={i} />
                    ))
                  ) : (
                    <h6 style={{ fontSize: "14px" }}>No records were found</h6>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>
  }
}
